module.exports = __webpack_public_path__ + "static/media/wsp.3887b103.png";